module.exports = __webpack_public_path__ + "static/media/NSCOMEX-LOGO-front.ae378e2f.png";